<template>
  <div class="wrapper">
    
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>

      <sidebar-link to="/admin/dashboard">
        <i class="nc-icon nc-chart-bar-32"></i>
        <p>Dashboard</p>
      </sidebar-link>

      <sidebar-link to="/admin/visitors">
        <i class="nc-icon nc-notes"></i>
        <p>Visitors</p>
      </sidebar-link>

      <sidebar-link to="/admin/attendance">
        <i class="nc-icon nc-check-2"></i>
        <!-- <i class="fa fa-clock-o" aria-hidden="true"></i> -->
        <p>Employee Attendance</p>
      </sidebar-link>

      <sidebar-link to="/admin/marketing" v-if="Marketing == true">
        <i class="nc-icon nc-notification-70"></i>
        <p>Marketing</p>
      </sidebar-link>

      <sidebar-link to="/admin/feedback" v-if="Feedback == true">
        <i class="nc-icon nc-favourite-28"></i>
        <p>Feedbacks</p>
      </sidebar-link>

<!--       <sidebar-link to="/admin/dashboar" v-if="Menu == true">
        <p>Menu</p>
      </sidebar-link>


      <sidebar-link to="/admin/menu-category" v-if="Menu == true">
        <i class="nc-icon nc-grid-45"></i>
        <p>Menu Category</p>
      </sidebar-link>

      <sidebar-link to="/admin/menu-items" v-if="Menu == true">
        <i class="nc-icon nc-bullet-list-67"></i >
        <p>Menu Items</p>
      </sidebar-link> -->

      <sidebar-link to="/admin/dashboar">
        <p>Setup</p>
      </sidebar-link>

      <sidebar-link to="/admin/tablet-management">
        <i class="nc-icon nc-tablet-2"></i>
        <p>Tablet Management</p>
      </sidebar-link>

      <sidebar-link to="/admin/myteam">
        <i class="nc-icon nc-badge"></i>
        <p>My Team</p>
      </sidebar-link>

      <sidebar-link to="/admin/user">
        <i class="nc-icon nc-circle-09"></i>
        <p>My Profile</p>
      </sidebar-link>      




<!--       <sidebar-link to="/admin/overview">
        <i class="nc-icon nc-notes"></i>
        <p>Overview</p>
      </sidebar-link>

      <sidebar-link to="/admin/table-list">
        <i class="nc-icon nc-notes"></i>
        <p>Table list</p>
      </sidebar-link>
      <sidebar-link to="/admin/typography">
        <i class="nc-icon nc-paper-2"></i>
        <p>Typography</p>
      </sidebar-link>
      <sidebar-link to="/admin/icons">
        <i class="nc-icon nc-atom"></i>
        <p>Icons</p>
      </sidebar-link>
      <sidebar-link to="/admin/maps">
        <i class="nc-icon nc-pin-3"></i>
        <p>Maps</p>
      </sidebar-link>
      <sidebar-link to="/admin/notifications">
        <i class="nc-icon nc-bell-55"></i>
        <p>Notifications</p>
      </sidebar-link> -->



    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  import { globalStore } from '../main.js';
  import { db } from '../main.js';

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    data () {
      return {
        Menu: false,
        Feedback: false, 
        Marketing: false
      }
    },
    beforeMount(){
      console.log("beforeMount");
      console.log("Dashboard Layout.");


      this.CheckLogin();
    },
    methods: {
      CheckLogin(){
        console.log("Check Login...");

          if(localStorage.getItem('AdminId')){

            globalStore.AdminId = localStorage.getItem('AdminId');
            globalStore.AdminName = localStorage.getItem('AdminName');
            globalStore.AdminEmail = localStorage.getItem('AdminEmail');

            console.log("AdminId: "+globalStore.AdminId);
            console.log("AdminName: "+globalStore.AdminName);
            console.log("AdminEmail: "+globalStore.AdminEmail);

            this.RefreshCompanyInfo();


          }
          else{
            console.log("admin object not set")
            this.$router.push('/login')
          }
      },
      RefreshCompanyInfo(){

                // Refresh CompanyInfo
                console.log("Refresh Company Info");
                console.log("CompanyId: "+globalStore.AdminId);

                db.collection('Company')
                  .doc(globalStore.AdminId)
                  .get()
                  .then((doc) => {

                    if(doc.exists){

                      console.log("------");
                      console.log("PricePlan: "+doc.data().PricePlan);
                      console.log("ContactPerson: "+doc.data().ContactPerson);
                      console.log("Mobile: "+doc.data().Mobile);
                      console.log("Email: "+doc.data().Email);
                      console.log("Menu: "+doc.data().Menu);
                      console.log("Feedback: "+doc.data().Feedback);
                      console.log("Marketing: "+doc.data().Marketing);
                      console.log("------");

                      globalStore.CompanyName = doc.data().CompanyName;
                      globalStore.PricePlan = doc.data().PricePlan;
                      globalStore.ContactPerson = doc.data().ContactPerson;
                      globalStore.Mobile = doc.data().Mobile;
                      globalStore.Email = doc.data().Email;
                      this.Menu = doc.data().Menu;
                      this.Feedback = doc.data().Feedback;
                      this.Marketing = doc.data().Marketing;

                      globalStore.UserInfo = doc.data();

                      this.CompanyName = globalStore.CompanyName;
                      this.ContactPerson = globalStore.ContactPerson;

                      if(doc.data().PricePlan == "Community"){
                        this.PricePlan = "COMMUNITY";              
                      }

                      if(doc.data().FreeTrialExpiry){

                        var date = doc.data().FreeTrialExpiry;
                        console.log("Expires On: "+date);

                        var a = moment();
                        var b = moment(date);
                        var c = a.diff(b, 'days') // 1
                        console.log("Diff: "+c);
                        this.DaysLeft = -1 * parseInt(c);

                        // --- Is 14 day Free Trial over ---
                        if(this.DaysLeft < 15){
                            this.showMsg = true;
                        }else{

                          // --- Trial is over, check is client has paid or not ---
                          // Check PricePlan value. If the trial is over and client has not paid the value will be "TrialExpired"
                          // If trial is over and client has paid, the value will be "Premium"
                            if(doc.data().PricePlan == 'TrialExpired'){
                              // --- Ask to Upgrade, hide screen ----
                              globalStore.Status = 'TrialExpired';
                              console.log("Status: "+globalStore.Status);
                            }else{
                              this.showMsg = false;
                            }

                        }

                      }

                    }
                  })
                  .catch((e) => {
                    console.log('Error:', (e));
                  });


      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
